import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { NewHeroComponent } from './new-hero.component';

@NgModule({
  imports: [
    CommonModule,
    
    MatIconModule,
    MatButtonModule
  ],
  exports: [
    NewHeroComponent
  ],
  providers: [
  ],
  declarations: [
    NewHeroComponent
  ]
})
export class NewHeroModule { }
